import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Archived",
  "use": "svg-icon-Archived-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Archived\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 4H6V1.999h4V4zm3 4H3V6h10v2zM2 10h14v6h-2v-4H2v4H0v-6h2z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol